(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
		popupSliderInit(true);
	}

	//This file is loaded from both the main-product.liquid and featured-product.liquid files
	// and is called twice. To avoid the variable being initialized and the slider being
	// instantiated multiple times, need to implement a isSwiperInit variable to prevent double initialization
	if (window.isSwiperInit) return;
	window.isSwiperInit = true;

	swiperInit();

	// Theme editor: re-create the gallery sliders for the section that was just re-rendered
	document.addEventListener('shopify:section:load', function (e) {
		if (typeof Swiper === 'undefined') return;
		if (e.target && e.target.querySelector('.js-media-list, .js-media-sublist')) {
			swiperInit();
		}
	});
})();
